import { render } from "./AlterarSenhaUsuario.vue?vue&type=template&id=28e37e98&scoped=true"
import script from "./AlterarSenhaUsuario.vue?vue&type=script&lang=js"
export * from "./AlterarSenhaUsuario.vue?vue&type=script&lang=js"

import "./AlterarSenhaUsuario.vue?vue&type=style&index=0&id=28e37e98&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/opt/vue/ped/ped-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e37e98"]])

export default __exports__